import React from 'react'
import { ProgressBar } from 'ui'
import { useValue } from '@morningtrain/react-resources'
import PropTypes from 'prop-types'
import { Translation } from '@morningtrain/react-translations'

export function OnboardingChecklistProgress (props) {
  const {
    progressName = 'fill_percentage',
    displayText = true,
    className
  } = props

  const fillPercentage = useValue(progressName)

  const progress = [
    { color: 'bg-primary-500', progress: fillPercentage }
  ]

  const completedFieldsCount = useValue('completed_fields_count')
  const finishedFieldsCount = useValue('filled_fields_count')
  const totalFields = useValue('fields_count')

  return (
    <div className={className}>
      {displayText
        ? (
          <Translation
            name='onboarding.tasks' data={{
              completed: completedFieldsCount,
              finished: finishedFieldsCount,
              total: totalFields
            }}
          />
          )
        : null}
      <ProgressBar progress={progress} />
    </div>
  )
}

OnboardingChecklistProgress.propTypes = {
  progressName: PropTypes.string,
  displayText: PropTypes.bool
}

export default OnboardingChecklistProgress
